/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/05/22
 */

import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';
import StateDisplay, { StateDisplayProps } from '@/components/StateDisplay/StateDisplay';
import { WorkplanNotLoadedAlert } from '@/components/WorkplanNotLoadedAlert/WorkplanNotLoadedAlert';
import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import React from 'react';

interface WorkplanStateDisplayProps
    extends Pick<StateDisplayProps<Workplan>, 'render' | 'renderLoading' | 'fullscreenLoading'> {
    renderError?: StateDisplayProps<Workplan>['errorRender'];
}

const WorkplanStateDisplay = ({ render, renderLoading, renderError, fullscreenLoading }: WorkplanStateDisplayProps) => {
    const { loading, workplan, error } = useWorkplan();
    return (
        <StateDisplay
            fullscreenLoading={fullscreenLoading}
            loading={loading}
            error={!!error}
            errorRender={renderError ?? (() => <WorkplanNotLoadedAlert />)}
            data={workplan}
            render={render}
            renderLoading={renderLoading}
        />
    );
};

export default WorkplanStateDisplay;
